export default "__VITE_PUBLIC_ASSET__4b347d18__"